/* eslint-disable eqeqeq */
/* eslint-disable @typescript-eslint/strict-boolean-expressions */
import ApiUtils from 'api/ApiUtils';
import React, {useState} from 'react';
import {Button, Col, Form, Row} from 'react-bootstrap';
import {
  type CategoryFormProps,
  type CategoryStatusList,
} from 'utils/TypeConfig';
import {useFormik} from 'formik';

import * as Yup from 'yup';
import {toast} from 'react-toastify';
import TooltipWithInfoIcon from 'Common/InfoTool';
import {tooltipMessage} from 'utils/Tooltips';
import {variables} from 'utils/constant';
const SuggestedFestivalForm: React.FC<CategoryFormProps> = ({
  handleClose,
  setIsEditCategory,
  setIsAddCategory,
  editCategory,
}) => {
  console.log('🚀 ~ editCategory:', editCategory);
  const [status] = useState([
    {
      id: variables.FESTIVAL_ACTIVE_STATUS_ID,
      name: variables.FESTIVAL_ACTIVE_STATUS,
    },
    {
      id: variables.FESTIVAL_INACTIVE_STATUS_ID,
      name: variables.FESTIVAL_INACTIVE_STATUS,
    },
  ]);

  const validation: any = useFormik({
    enableReinitialize: true,
    initialValues: {
      name: editCategory?.name !== '' ? editCategory?.name : '',
      is_active: editCategory?.is_active !== '' ? editCategory?.is_active : '',
    },
    validationSchema: Yup.object({
      name: Yup.string().required('Festival name is required'),
      is_active: Yup.number().required('Status is required'),
    }),
    onSubmit: async (values: any): Promise<void> => {
      console.log('🚀 ~ onSubmit: ~ values:', values);

      try {
        const formData = {
          name: values.name,
          // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
          is_active: values.is_active,

          // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
          ...(editCategory?.id ? {id: editCategory?.id} : {}),
          ...(editCategory?.id ? {} : {status: 1}),
          // brand: selectedBrandOption.map((brand: any, index: number) => ({
          //   id: brand.value,
          // })),
        };

        if (typeof values?.image !== 'string') {
          (formData as any).image = values?.image;
        }
        console.log('🚀 ~ onSubmit: ~ formData:', formData);
        try {
          // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
          const response: any = editCategory?.id
            ? await ApiUtils.updateFestival(formData)
            : await ApiUtils.addFestival(formData);
          // eslint-disable-next-line @typescript-eslint/no-floating-promises, @typescript-eslint/strict-boolean-expressions
          if (setIsEditCategory) {
            setIsEditCategory((prev: boolean) => !prev);
          }
          if (setIsAddCategory) {
            setIsAddCategory((prev: boolean) => !prev);
          }
          handleClose();
          toast.success(response?.message);
          // void getCategoryList();
        } catch (error: any) {
          toast.error(error?.response?.data?.message);
        }
      } catch (err: any) {
        toast.error(err);
      }
    },
  });

  // console.log(editCategory?.id, 'categoryList');
  return (
    <div>
      <Form
        className="tablelist-form"
        onSubmit={e => {
          e.preventDefault();
          validation.handleSubmit();
        }}>
        <Row>
          <div
            id="alert-error-msg"
            className="d-none alert alert-danger py-2"></div>
          <input type="hidden" id="id-field" />

          <Col lg={12}>
            <div className="mb-3">
              <div className="d-flex">
                <Form.Label htmlFor="category-name">
                  Festival Name
                  <span className="text-danger required-mark">*</span>
                </Form.Label>

                <TooltipWithInfoIcon text={tooltipMessage.CategoryName} />
              </div>
              <Form.Control
                type="text"
                id="event-name"
                placeholder="Enter Festival Name"
                name="name"
                onChange={validation.handleChange}
                onBlur={validation.handleBlur}
                defaultValue={
                  // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
                  validation?.values?.name || editCategory?.name
                    ? editCategory?.name
                    : ''
                }
                isInvalid={
                  !!(
                    Boolean(validation.touched.name) &&
                    Boolean(validation.errors.name)
                  )
                }
              />
              {Boolean(validation.touched.name) &&
              Boolean(validation.errors.name) ? (
                <Form.Control.Feedback className="required-mark" type="invalid">
                  {validation.errors.name}
                </Form.Control.Feedback>
              ) : null}
            </div>
          </Col>

          <Col lg={12}>
            <div className="mb-3">
              <div className="d-flex">
                <Form.Label htmlFor="status-Field">Status</Form.Label>

                <TooltipWithInfoIcon text={tooltipMessage.CategoryStatus} />
              </div>
              <Form.Select
                className="form-select"
                name="is_active"
                id="status-Field"
                onChange={e =>
                  validation.setFieldValue('is_active', e.target.value)
                }
                value={
                  validation.values.is_active ||
                  (editCategory?.is_active !== ''
                    ? editCategory?.is_active
                    : '')
                }
                isInvalid={
                  !!(
                    validation.touched.is_active && validation.errors.is_active
                  )
                }>
                <option value=" ">Status</option>
                {status?.map((data: CategoryStatusList, i) => (
                  <option key={i} value={data.id}>
                    {data.name}
                  </option>
                ))}
              </Form.Select>

              {Boolean(validation.touched.is_active) &&
              Boolean(validation.errors.is_active) ? (
                <Form.Control.Feedback className="required-mark" type="invalid">
                  {validation.errors.is_active}
                </Form.Control.Feedback>
              ) : null}
            </div>
          </Col>

          <Col lg={12} className="modal-footer">
            <div className="hstack gap-2 justify-content-end">
              <Button variant="dark" id="add-btn" type="submit">
                {editCategory?.id !== undefined
                  ? 'Edit Festival'
                  : 'Add Festival'}
              </Button>
            </div>
          </Col>
        </Row>
      </Form>
    </div>
  );
};

export default SuggestedFestivalForm;
